import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LayoutService } from '@core/services/layout.service';

@Component({
  selector: 'app-navigation',
  imports: [MatIconModule, RouterLink, RouterLinkActive],
  templateUrl: './navigation.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Navigation {
  readonly layout = inject(LayoutService);
}
